<div id="registrationForm">
  <div class="content leading-5">
    <img id="registration-logo" [src]="logo" aria-hidden="true" />

    <div class="regFormContainer">
      @if (!componentLoaded || inProgress) {
        <app-sms-spinner [data]="loadingMessage" size="1x"></app-sms-spinner>
      } @else {
        @if (!displayInvalidAcct) {
          <p class="p-2">Leverage your time, make more money and put your business in a position of distinction with <span class="_font--bold">Lead Advantage Pro!</span></p>
        }
        @if (displayInvalidAcct || displayRoleExpired || displayAcctInfo ||  (registrationMessage$ | async)) {
          @if ((registrationMessage$ | async) == '') {
<mat-card appearance="outlined" class="regFormNotice" role="alert" [ngClass]="{
                            'alert': displayInvalidAcct || displayRoleExpired
                        }">
              <mat-card-content>
                <div class="flex flex-row gap-4 items-start">
                  <span class="text-4xl">
                    <mat-icon inline class="icon" aria-hidden="true" [ngClass]="{ 'warn-alt': displayAcctInfo }">
                      @if (displayInvalidAcct || displayRoleExpired) {
                        warning
                      } @else {
                        warning_amber
                      }
                    </mat-icon>
                  </span>
                  <p>
                    @if (displayInvalidAcct) {
                      <span>
                        The registration link used is no longer valid. Please contact Lead Advantage Pro support at 1-877-645-0147. If you'd like to register for Lead Advantage Pro please visit Lead Advantage Pro at <a href="https://seniormarketsales.com" target="_blank">https://seniormarketsales.com</a>.
                      </span>
                    }
                    @if (displayRoleExpired) {
                      <span>
                        Please contact {{ accountOwnerName }} at {{ accountOwnerEmail }} or <span>{{ accountOwnerPhone | phone }}</span> as the user role is no longer valid for this link.
                      </span>
                    }
                    @if (displayAcctInfo) {
                      <span>
                        Your registration will create a user profile within {{ accountOwnerName }}'s Lead Advantage Pro account ({{ accountId }}). If this is not what you intend, do not proceed. You may contact {{accountOwnerName}} at {{accountOwnerEmail}}@if (accountOwnerPhone) {
                        <span> or {{ accountOwnerPhone | phone }}</span>
                        }.
                      </span>
                    }
                  </p>
                  <mat-icon inline class="icon--close" (click)="closeNotice()">close</mat-icon>
                </div>
              </mat-card-content>
            </mat-card>
          }
          @if (registrationAttempt && (registrationMessage$ | async)) {
<mat-card appearance="outlined" class="regFormNotice" role="alert" [ngClass]="{
                            'alert': hasError,
                            'success': !hasError
                        }">
              <mat-card-content>
                <div class="flex flex-row gap-4 items-start text-white">
                  <mat-icon inline class="icon w-[5%]" aria-hidden="true">
                    @if (!hasError) {
                      done
                    } @else {
                      warning
                    }
                  </mat-icon>
                  @if (registrationMessage$ | async; as regMessage) {
                    <p class="w-[90%]" [innerHTML]="regMessage"></p>
                  }
                  <mat-icon inline class="icon--close w-[5%]" (click)="closeNotice()">close</mat-icon>
                </div>
              </mat-card-content>
            </mat-card>
          }
        }
        @if (!displayInvalidAcct) {
          <form id="userRegistrationForm" name="userRegistrationForm" novalidate method="POST" autocomplete="off" (submit)="submitForm()" [formGroup]="userRegistrationForm">
            <p class=" text-xs p-2"><span class="requiredIndicator">*</span> denotes a required field.</p>
            <mat-card appearance="outlined" class="mb-2">
              <mat-card-content>
                <mat-card-title class="text-center">Your ID and Password</mat-card-title>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>Username:</mat-label>
                    <input matInput autocomplete="new-password" required name="login" maxlength="15" formControlName="login" />
                    @if (login.hasError('required')) {
                      <mat-error>Username is <strong>required</strong>.</mat-error>
                    }
                    @if (login.hasError('minlength') || login.hasError('maxlength') || login.hasError('pattern')) {
                      <mat-error>Username must be <strong>6-15 letters or numbers</strong>.</mat-error>
                    }
                  </mat-form-field>
                  <div class="w-1/2">
                    <p class="py-2">Must be between 6-15 alphanumeric characters.</p>
                  </div>
                </div>
                <div class="flex flex-row gap-4">
                  <div class="w-1/2">
                    <mat-form-field class="w-full">
                      <mat-label>Password:</mat-label>
                      <input matInput autocomplete="new-password" required name="password" type="password" formControlName="password" />
                      @if (password.hasError('required')) {
                        <mat-error>Password is <strong>required</strong>.</mat-error>
                      }
                      @if (password.hasError('pattern')) {
                        <mat-error>Password must meet the <strong>minimum strength</strong> as defined.</mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="w-full">
                      <mat-label>Confirm Password:</mat-label>
                      <input matInput autocomplete="new-password" required name="confirmPwd" type="password" formControlName="confirmPwd" />
                      @if (confirmPwd.hasError('required')) {
                        <mat-error>Must <strong>confirm</strong> Password.</mat-error>
                      }
                      @if (confirmPwd.hasError('confirmedValidator')) {
                        <mat-error>Password must <strong>match</strong>.</mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="w-1/2">
                    <ul class="list-disc mx-2">
                      <li>At least 8 characters long.</li>
                      <li>Must contain at least 1 capital letter.</li>
                      <li>Must contain at least 1 lower case letter.</li>
                      <li>Must contain at least 1 number.</li>
                      <li>Must contain at least 1 of the following special characters (!,&#64;,#,$,&,*).</li>
                    </ul>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-card-content>
                <mat-card-title class="text-center">Contact Information</mat-card-title>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>Business Name:</mat-label>
                    <input matInput name="business" maxlength="50" formControlName="company" />
                  </mat-form-field>
                </div>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>First Name:</mat-label>
                    <input matInput required name="fname" formControlName="fname" />
                    @if (fname.hasError('required')) {
                      <mat-error>First Name is <strong>required</strong>.</mat-error>
                    }
                    @if (fname.hasError('pattern')) {
                      <mat-error>First Name must contain <strong>letters, spaces,</strong> and <strong>hyphens</strong> only.</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field class="w-1/2">
                    <mat-label>Last Name:</mat-label>
                    <input matInput required name="lname" formControlName="lname" />
                    @if (lname.hasError('required')) {
                      <mat-error>Last Name is <strong>required</strong>.</mat-error>
                    }
                    @if (lname.hasError('pattern')) {
                      <mat-error>Last Name must contain <strong>letters, spaces,</strong> and <strong>hyphens</strong> only.</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>Email Address:</mat-label>
                    <input matInput required type="email" name="email" formControlName="email" />
                    @if (email.hasError('required')) {
                      <mat-error>Email Address is <strong>required</strong>.</mat-error>
                    }
                    @if (email.hasError('email')) {
                      <mat-error>Enter a <strong>valid</strong> Email Address.</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>Street Address 1:</mat-label>
                    <input matInput required name="address1" formControlName="address1" />
                    @if (address1.hasError('required')) {
                      <mat-error>Street Address 1 is <strong>required</strong>.</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>Street Address 2:</mat-label>
                    <input matInput name="address2" formControlName="address2" />
                  </mat-form-field>
                </div>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>City:</mat-label>
                    <input matInput required name="city" formControlName="city" />
                    @if (city.hasError('required')) {
                      <mat-error>City is <strong>required</strong>.</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>State:</mat-label>
                    <mat-select required name="state" formControlName="state_id">
                      @for (state of statesList; track state) {
                        <mat-option [value]="state.abbreviation">{{state.name}}</mat-option>
                      }
                    </mat-select>
                    @if (state_id.hasError('required')) {
                      <mat-error>State is <strong>required</strong>.</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>Zip Code:</mat-label>
                    <input matInput required name="zip" maxlength="5" appNumbersOnly formControlName="zip" />
                    @if (zip.hasError('required')) {
                      <mat-error>Zip Code is <strong>required</strong>.</mat-error>
                    }
                    @if (zip.hasError('pattern')) {
                      <mat-error>Enter a <strong>valid</strong> Zip Code.</mat-error>
                    }
                  </mat-form-field>
                  <div class="w-1/2">
                    <p class="py-2">Please enter a five digit number.</p>
                  </div>
                </div>
                <div class="flex flex-row">
                  <p class="text-sm">A business phone or mobile phone is required to complete registration.</p>
                </div>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>Business Phone:</mat-label>
                    <input matInput type="tel" name="phone" maxlength="14" appPhoneNumberMask formControlName="phone" />
                    @if (phone.hasError('pattern')) {
                      <mat-error>Enter a <strong>valid</strong> Business Phone.</mat-error>
                    }
                  </mat-form-field>
                  <div class="w-1/2">
                    <p class="py-2">Please enter a ten digit number.</p>
                  </div>
                </div>
                <div class="flex flex-row gap-4">
                  <mat-form-field class="w-1/2">
                    <mat-label>Mobile Phone:</mat-label>
                    <input matInput type="tel" name="mphone" maxlength="14" appPhoneNumberMask formControlName="mphone" />
                    @if (mphone.hasError('pattern')) {
                      <mat-error>Enter a <strong>valid</strong> Mobile Phone.</mat-error>
                    }
                  </mat-form-field>
                  <div class="w-1/2">
                    <p class="py-2">Please enter a ten digit number.</p>
                  </div>
                </div>
                <div class="flex flex-row">
                  <p class="text-sm">After registration is complete, you will be able to configure Communication Preferences to receive
                    transactional texts messages - <span class="font-semibold">a mobile phone number must be on file</span>.</p>
                  </div>
                  <div class="flex flex-row gap-4">
                    <mat-form-field class="w-1/2">
                      <mat-label>Fax Number:</mat-label>
                      <input matInput type="tel" name="fphone" maxlength="14" appPhoneNumberMask formControlName="fphone" />
                      @if (fphone.hasError('pattern')) {
                        <mat-error>Enter a <strong>valid</strong> Fax Number.</mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="flex flex-row gap-4">
                    <mat-form-field class="w-1/2">
                      <mat-label>National Producer Number (NPN):</mat-label>
                      <input matInput name="npn" formControlName="npn" [readonly]="hasNoNPN.value == true" />
                      @if (npn.hasError('pattern')
                        || npn.hasError('missingNPN')) {
                        <mat-error class="w-[200%]">Enter a <strong>valid</strong> NPN or click the checkbox if you do not have one.</mat-error>
                      }
                    </mat-form-field>
                    <div id="npnSearch" class="w-1/2">
                      @if (!displayInvalidAcct && !displayRoleExpired) {
                        <a href="https://www.nipr.com/PacNpnSearch.htm" target="_blank">Find your NPN.</a>
                        <mat-checkbox formControlName="hasNoNPN">I don't have an NPN</mat-checkbox>
                      }
                    </div>
                  </div>
                  <div class="flex flex-row gap-4">
                    <mat-form-field class="w-1/2">
                      <mat-label>Website URL:</mat-label>
                      <input matInput name="website" formControlName="website" />
                    </mat-form-field>
                  </div>
                </mat-card-content>
                @if ((!this.userRegistrationForm.pristine && !hasError) || !disabledAccount) {
                  <mat-card-actions align="end">
                    <button [disabled]="inProgress" mat-button mat-flat-button color="primary" type="submit">Submit</button>
                  </mat-card-actions>
                }
              </mat-card>
            </form>
          }
        }


      </div>
    </div>
  </div>
